import { EMediaType, IImageItemSchema, TMediaItemSchema } from '../../components/Carousel/interfaces';

export function isImage(item: TMediaItemSchema): item is IImageItemSchema {
  return item.mediaType === EMediaType.Image;
}
